module.exports = __webpack_public_path__ + "officialStatic/img/product-swgk.cdd978f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-swgk.png
// module id = X3xA
// module chunks = 0